export const SET_PLAYER_TEXT = 'SERVERMENU_TEXTS_SET_PLAYER_TEXT'
export const SET_PLAYERS_TEXT = 'SERVERMENU_TEXTS_SET_PLAYERS_TEXT'
export const SET_TESTSERVER_TEXT = 'SERVERMENU_TEXTS_SET_TESTSERVER_TEXT'
export const SET_TESTSERVERWARNING_TEXT = 'SERVERMENU_TEXTS_SET_TESTSERVERWARNING_TEXT'
export const SET_ONTESTSERVER_TEXT = 'SERVERMENU_TEXTS_SET_ONTESTSERVER_TEXT'
export const SET_TEXTS = 'SERVERMENU_TEXTS_SET_TEXTS'



// WEBPACK FOOTER //
// ./src/features/ServerMenu/data/texts/constants.js